import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import { useCompanyQuery } from '../company/useCompanyQuery';

import { insightsApi } from './api';

export const useAdNetworksQuery = () => {
  const { isOpen } = useAppState();
  const { domain: companyDomain = '' } = useCompanyQuery().data || {};

  const query = useQuery({
    queryKey: ['ad-networks', companyDomain],
    queryFn: async ({ signal }) => await insightsApi.getAdNetworks(companyDomain, signal),
    enabled: isOpen && !!companyDomain,
    retry: false,
    refetchInterval: false,
  });

  return query;
};
